var map = {
	"./GustavAttackPortal.json": [
		647,
		29
	],
	"./GustavDustParticleBackLeft.json": [
		648,
		30
	],
	"./GustavDustParticleBackRight.json": [
		649,
		31
	],
	"./GustavDustParticleFrontLeft.json": [
		650,
		32
	],
	"./GustavDustParticleFrontRight.json": [
		651,
		33
	],
	"./GustavEmberParticle.json": [
		652,
		34
	],
	"./GustavFinalAttackPortal.json": [
		653,
		35
	],
	"./GustavFinalDustParticleBackLeft.json": [
		654,
		36
	],
	"./GustavFinalDustParticleBackRight.json": [
		655,
		37
	],
	"./GustavFinalDustParticleFrontLeft.json": [
		656,
		38
	],
	"./GustavFinalDustParticleFrontRight.json": [
		657,
		39
	],
	"./GustavFinalGroundHitParticle.json": [
		658,
		40
	],
	"./GustavFinalSwordParticle.json": [
		659,
		41
	],
	"./GustavGroundHitParticle.json": [
		660,
		42
	],
	"./GustavSwordParticle.json": [
		661,
		43
	],
	"./smoke.json": [
		662,
		44
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1180;
module.exports = webpackAsyncContext;